/*eslint-disable*/
import { useState } from "react";
import {
  NavLink as NavLinkRRD,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  // InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
// GraphQL
import { useQuery, useMutation } from "@apollo/client";
import CurrentUser from "../../queries/CurrentUser";
import Logout from "../../mutations/Logout";

const Sidebar = (props) => {
  const navigate = useNavigate();

  const [logoutUser] = useMutation(Logout, {
    update(cache) {
      // Remove the currentUser from the cache
      cache.evict({ fieldName: "currentUser" });
      cache.evict({ fieldName: "currentUserData" });
    },
    onCompleted() {
      // Additional actions after logout (e.g., redirecting)
      navigate("/login");
    },
  });

  function onLogoutClick() {
    logoutUser();
  }

  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // location
  const location = useLocation();
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      const pathParent = prop.path.split("/")[1];
      // if the route should be excluded from the main nav, return null
      if (prop.invisible) return null;
      // if the route is a child, return null when pathParent is not equal to the current path
      if (prop.child && pathParent !== location.pathname.split("/")[2])
        return null;

      if (prop.layout === props.role) {
        if (
          props.currentUser?.role === "report_viewer" &&
          !prop.path.startsWith("/reports")
        ) {
          return null;
        }

        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              className={prop.child ? "ml-4" : ""}
            >
              <i className={prop.icon} />
              {prop.name}
            </NavLink>
          </NavItem>
        );
      }
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white justify-content-start"
      container={false}
      expand="md"
      id="sidenav-main"
    >
      {/* Toggler */}
      <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
        <span className="navbar-toggler-icon" />
      </button>
      {/* Brand */}
      {logo ? (
        <NavbarBrand className="px-3 pt-0 pt-md-3" {...navbarBrandProps}>
          <img
            alt={logo.imgAlt}
            className="navbar-brand-img"
            src={logo.imgSrc}
            style={{ maxHeight: "2rem" }}
          />
        </NavbarBrand>
      ) : null}
      {/* Collapse */}
      <Collapse navbar isOpen={collapseOpen}>
        {/* Collapse header */}
        <div className="navbar-collapse-header d-md-none">
          <Row>
            {logo ? (
              <Col className="collapse-brand" xs="6">
                {logo.innerLink ? (
                  <Link to={logo.innerLink}>
                    <img alt={logo.imgAlt} src={logo.imgSrc} />
                  </Link>
                ) : (
                  <a href={logo.outterLink}>
                    <img alt={logo.imgAlt} src={logo.imgSrc} />
                  </a>
                )}
              </Col>
            ) : null}
            <Col className="collapse-close" xs="6">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleCollapse}
              >
                <span />
                <span />
              </button>
            </Col>
          </Row>
        </div>
        {/* Navigation */}
        <Nav navbar>{createLinks(routes)}</Nav>
        {/* Divider */}
        <hr className="my-3" />
        {/* Logout */}
        <Nav className="mb-md-3" navbar>
          <NavItem>
            <NavLink tag={Link} onClick={() => onLogoutClick()}>
              <i className="ni ni-button-power text-default" />
              Logout
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
